/* eslint max-len: 0 */
import gql from 'graphql-tag';
import { last } from 'lodash';

export const CreateCarrierMapping = gql`
  mutation CreateCarrierMapping($input: CarrierShipToMappingInput!) {
    carrierShipToMapping(
      operation: "CREATE"
      input: $input
    ) {
      PK
      SK
      ShipTo {
        ShipToNumber
        ShipToName
        ShipToAddressLine1
        ShipToAddressLine2
        ShipToAddressLine3
        ShipToCity
        ShipToPostCode
        ShipToEmail
        CarrierEmail
      }
      CreatedAt
      UpdatedAt
    }
  }
`;

export const ListCarrierMappings = gql`
  query ListCarrierPlantsWithPagination ($CarrierId: String!, $Limit: Int, 
  $LastEvaluatedKey: String) {
    getCarrierShipToMappings(
      CarrierId: $CarrierId
      Limit: $Limit,
      LastEvaluatedKey: $LastEvaluatedKey
    ) {
      Items {
        PK
        SK
        SAPPlantId
        ShipTo {
          ShipToNumber
          ShipToName
          ShipToAddressLine1
          ShipToAddressLine2
          ShipToAddressLine3
          ShipToCity
          ShipToPostCode
          ShipToEmail
          CarrierEmail
        }
        CreatedAt
      }
      Count
      LastEvaluatedKey
    }
  }
`;

// Example CarrierName: ABC Logistics
// Example CarrierId: CAR123
// Example ShipToNumber: ST001
export const UpdateCarrierMapping = gql`
  mutation UpdateCarrierMapping($input: CarrierShipToMappingInput!) {
    carrierShipToMapping(
      operation: "UPDATE"
      input: $input
    ) {
      PK
    SK
    CarrierId
    SAPPlantId     
    ShipTo {
      ShipToNumber
      ShipToName
      ShipToAddressLine1
      ShipToAddressLine2
      ShipToAddressLine3
      ShipToCity
      ShipToPostCode
      ShipToEmail
      CarrierEmail
    }
    CreatedAt
    UpdatedAt
    }
  }
`;

// Example CarrierName: ABC Logistics
// Example CarrierId: CAR123
// Example ShipToNumber: ST001
export const DeleteCarrierMapping = gql`
  mutation DeleteCarrierMapping($CarrierId: String!, $SAPPlantId: String!, $ShipToNumber: String!) {
    carrierShipToMapping(
      operation: "DELETE"
      CarrierId: $CarrierId
      SAPPlantId: $SAPPlantId
      ShipToNumber: $ShipToNumber
    ) {
      PK
      SK
      CarrierId
      SAPPlantId
      ShipTo {
        ShipToNumber
        ShipToName
      }
      UpdatedAt
    }
  }
`;


/**
 * @param {*} graphClient AWS Graphclient
 * @param {*} mappingData - contains mapping data values
 */
export const createCarrierMapping = async (graphClient, mappingData) => {
  try {
    let response = await graphClient.mutate({
      mutation: CreateCarrierMapping,
      variables: {
        input: mappingData,
      },
    });
    return { data: response.data.carrierShipToMapping ? response.data.carrierShipToMapping : null };
  } catch (e) {
    console.log('Error! while register: createCarrierMapping', e);
    return { error: e.message };
  }
};

/**
 * Get ship to mappings.
 * @param {*} graphClient AWS Graph Client
 * @param {*} carrierData Valid carrierData object
 * @param {*} pagination Pagination options { limit, lastEvaluatedKey }
 * @returns carrier mapping listing response
 */
export const getCarrierMappings = async (graphClient, carrierData, pagination = {}) => {
  if (!carrierData || !carrierData.CarrierId) {
    throw new Error('CarrierId is required');
  }
  const variables = {
    CarrierId: carrierData.CarrierId,
  };

  if (pagination.pagination.limit) {
    variables.Limit = pagination.pagination.limit;
  }
  // if (pagination.pagination.lastEvaluatedKey) {
  //   variables.LastEvaluatedKey = pagination.pagination.lastEvaluatedKey;
  // }

  try {
    const response = await graphClient.query({
      query: ListCarrierMappings,
      variables,
      fetchPolicy: 'network-only', // Doesn't check cache before making a network request
    });
    return response;
  } catch (error) {
    // If error contains "Cannot return null for non-nullable", try to extract partial data
    if (error.message?.includes('Cannot return null for non-nullable') && error.graphQLErrors) {
      console.warn('GraphQL returned partial data with null values, attempting to recover');
      // Return empty result set to let the UI filtering handle it
      return {
        data: {
          getCarrierShipToMappings: {
            Items: [],
            Count: 0,
            LastEvaluatedKey: null
          }
        }
      };
    }
    throw error;
  }
};

/**
 * @param {*} graphClient AWS Graphclient
 * @param {*} mappingData - contains mapping data values
 */
export const updateCarrierMapping = async (graphClient, mappingData) => {
  try {
    let response = await graphClient.mutate({
      mutation: UpdateCarrierMapping,
      variables: {
        input: mappingData,
      },
    });
    return { data: response.data.carrierShipToMapping ? response.data.carrierShipToMapping : null };
  } catch (e) {
    console.log('Error! while updating carrier mapping:', e);
    return { error: e.message };
  }
};

/**
 * @param {*} graphClient AWS Graphclient
 * @param {*} dropDetail - contains PK and SK
 * @param {*} dropData - contains DropId
 */
export const deleteCarrierMapping = async (graphClient, CarrierId, SAPPlantId, ShipToNumber) => {
  const response = await graphClient.mutate({
    mutation: DeleteCarrierMapping,
    variables: {
      CarrierId: CarrierId,
      SAPPlantId: SAPPlantId,
      ShipToNumber: ShipToNumber,
    },
  });
  return response;
};